import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { FileService } from "files/files.service";

@Injectable({ providedIn: "root" })
export class PropertiesResolverResolver implements Resolve<stages.file.FileProperties> {
	constructor(private fileService: FileService) {}

	async resolve(route: ActivatedRouteSnapshot): Promise<stages.file.FileProperties> {
		return this.fileService.getFileProperties(
			route.paramMap.get("fileId")!,
			route.paramMap.get("workspaceId")!,
			route.paramMap.get("processVersion")!,
		);
	}
}
